import { EmptyState, ErrorState, LoadingState, useLocale } from '@nolens/ui';
import type { UseQueryResult } from '@tanstack/react-query';
import type { ReactNode } from 'react';
import { ApiError } from '../lib/api';
import { componentsText } from '../i18n/components';

/** Estados de carregamento e erro para qualquer pedido. */
export function QueryView<T>({
  q,
  children,
}: {
  q: UseQueryResult<T>;
  children: (data: T) => ReactNode;
}) {
  const t = componentsText(useLocale());
  if (q.isPending) return <LoadingState />;
  if (q.isError) {
    if (q.error instanceof ApiError && (q.error.status === 404 || q.error.status === 403)) {
      return <EmptyState title={t.notFound} description={t.notFoundHint} />;
    }
    return (
      <ErrorState
        title={t.couldNotLoad}
        description={q.error instanceof ApiError ? q.error.message : t.tryAgain}
        onRetry={() => void q.refetch()}
        requestId={q.error instanceof ApiError ? q.error.requestId : undefined}
      />
    );
  }
  return <>{children(q.data)}</>;
}
